import { render, staticRenderFns } from "./selectProjectBom.vue?vue&type=template&id=aa853c64&scoped=true&"
import script from "./selectProjectBom.vue?vue&type=script&lang=js&"
export * from "./selectProjectBom.vue?vue&type=script&lang=js&"
import style0 from "./selectProjectBom.vue?vue&type=style&index=0&id=aa853c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa853c64",
  null
  
)

export default component.exports